import { tracked } from '@glimmer/tracking';
import { waitForNext } from '../../../../utils/waiters';
import Super from '../base.gjs';

/**
 * Class that provides infrastructure for registering menu items
 * @property {string} elementName the name of the attribute that the traversable DOM element
 * is saved as on the menu item component
 * @property {array} #registeredItems a private copy of the items array
 */
export default class SpdsCoreMenuParent extends Super {
  #registeredItems = [];
  elementName = 'baseElement';

  @tracked items = [];

  /**
   * computed property that returns the traversable DOM element for all menu items
   */
  get navigableOptions() {
    return this.items.map(item => item[this.elementName]);
  }

  registerItem = async (append, item) => {
    this.#registeredItems = append
      ? [item, ...this.#registeredItems]
      : [...this.#registeredItems, item];

    await waitForNext();

    this.updateItems();
  };

  unregisterItem = id => {
    let index = this.#registeredItems.findIndex(item => item.id === id);

    if (index > -1) {
      this.#registeredItems.splice(index, 1);

      this.updateItems();
    }
  };

  updateItems = () => {
    this.items = [...this.#registeredItems];
  };
}
